import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PowerBIService } from '../reports/powerbiservice.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-landingpage',
    templateUrl: './landingpage.component.html',
    styleUrls: ['./landingpage.component.scss'],
    standalone: false
})
export class LandingpageComponent implements OnInit {

  private pbiSvcSubscription: Subscription;

  constructor(private route: Router, private pbiSvc: PowerBIService) { }

  ngOnInit() {
    
    this.pbiSvcSubscription = this.pbiSvc.getAllReports().subscribe((response) => {
      //console.log(response);
      var reportLinks = [...response];
      var defaultReport = reportLinks.filter(x => x.isDefaultReport);
      if (defaultReport && defaultReport.length > 0) {
        var reportTagName = defaultReport[0].tag as string;
        if (!reportTagName)
          reportTagName = 'CaseyFinkExperience';

        //console.log('reportTagName', reportTagName);
        const reportURL = this.pbiSvc.getReportURL(reportTagName);
        //console.log('reportURL', reportURL);
        this.route.navigate([reportURL]);
        
      }
    });
  }

  ngOnDestroy() {
    this.pbiSvcSubscription.unsubscribe();
  }
}
